import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { DeploymentService } from '../store/deployment.service';
import { Subscription } from 'rxjs';
import { LssDeploymentEntity } from '../store/deployment.datamodel';
import { AppService } from '../../application/app.service';

@Component({
    selector: 'ama-ng-app-store-deployment-summary',
    templateUrl: './deployment-summary.component.html',
    styleUrls: ['./deployment-summary.component.scss'],
    standalone: false
})
export class DeploymentSummaryComponent implements OnDestroy {
  @Output() pushApp: EventEmitter<void> = new EventEmitter<void>();
  toBeDeployed: LssDeploymentEntity[] = [];
  toBeExcluded: LssDeploymentEntity[] = [];
  toBeUndeployed: LssDeploymentEntity[] = [];
  toBeUnexcluded: LssDeploymentEntity[] = [];
  toRemoveOverrides: LssDeploymentEntity[] = [];
  anyChanges = false;
  appId: string | undefined = undefined;

  private readonly subscription: Subscription = new Subscription();

  constructor(private readonly deploymentService: DeploymentService, private readonly appService: AppService) {
    this.subscription.add(deploymentService.selectEntitiesToBeDeployed$
      .subscribe(entities => {
        this.toBeDeployed = entities;
      }
  ));
    this.subscription.add(deploymentService.selectEntitiesToBeExcluded$
      .subscribe(entities => {
          this.toBeExcluded = entities;
        }
      ));
    this.subscription.add(deploymentService.selectEntitiesToBeUndeployed$
      .subscribe(entities => {
          this.toBeUndeployed = entities;
        }
      ));
    this.subscription.add(deploymentService.selectEntitiesToBeUnexcluded$
      .subscribe(entities => {
          this.toBeUnexcluded = entities;
        }
      ));
    this.subscription.add(deploymentService.selectEntitiesToRemoveOverrides$
      .subscribe(entities => {
          this.toRemoveOverrides = entities;
        }
      ));
    this.subscription.add(deploymentService.isAnyChange$
      .subscribe(anyChanges => this.anyChanges = anyChanges)
    );
    this.subscription.add(appService.detailedApp$.subscribe(app => {
      this.appId = app.id;
    }));
  }

  /**
   * Remove changes
   */
  cancel() {
    if (this.appId) {
      this.deploymentService.dispatchRemoveUncommittedChanges(this.appId);
    }
  }

  /**
   * Apply changes
   */
  apply() {
    this.pushApp.emit();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
